export default {
  Cancelado: 4,
  Concluido: 3,
  EmAndamento: 2,
  Falha: 5,
  NaoIniciado: 1,
};
